@if (spinner) {
  <div class="loader loader--fs show" >
    <div class="loader__inner">
      <ng-lottie [options]="options"></ng-lottie>
      <div class="loader__text">
        One moment, please…
      </div>
    </div>
  </div>
}
<div class="modal fade modal--alert"
  id="pause-policy-alert-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delete-alert-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + ( policy?.category_id ? policy?.category_id : policy?.product_category_id  )+ '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" (click)="closePausePolicyAlertModal()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Pause cover on the {{entity === entities.Policy ? 'policy ' + policy?.product_name :
            entity === entities.Item ? 'item ' + (item?.description_2 ? item?.description_2 : item?.item_description_2 ) : 'addon ' + vap?.detail}}</h4>
            <p>Please set the start and end dates to pause your cover. You won’t be charged during this time. Once the
            paused period is over your cover will resume as before. </p>
          </div>
          <div class="form-group mb-0">
            <div class="form-group__calrange">
              <div class="form-group__calrange-start">
                <app-question-date-picker
                  [numberMonths]="1"
                  [showLabel]="true"
                  [showControlLabel]="true"
                  [controlLabel]="'Pause'"
                  [minDate]="dates?.min_date"
                  [maxDate]="dates?.max_date"
                  [initialDate]="dates?.default_date"
                  [showIcon]="true"
                  [category]="policy?.category_id"
                  (questionAnswer)="setStartDate($event)">
                </app-question-date-picker>
              </div>
              <div class="form-group__calrange-to">
                <svg class="icon"><use xlink:href="#right-small"></use></svg>
              </div>
              <div class="form-group__calrange-end">
                <app-question-date-picker
                  [numberMonths]="1"
                  [showLabel]="true"
                  [showControlLabel]="true"
                  [controlLabel]="'Resume'"
                  [minDate]="dates?.min_date"
                  [maxDate]="endMaxDate"
                  [initialDate]="endDate"
                  [showIcon]="true"
                  [category]="policy?.category_id"
                  (questionAnswer)="setEndDate($event)">
                </app-question-date-picker>
              </div>
            </div>
          </div>

          <!-- <app-question-multiple-date-picker
          [startMinDate]="dates?.min_date"
          [startMaxDate]="dates?.max_date"
          [endMaxDate]="dates?.max_date"
          [numberMonths]="1"
          [startLabel]="'Pause'"
          [endLabel]="'Resume'"
          [category]="policy?.category_id"
          [dateFormat]="'dd/MM/yyyy'"
          (questionAnswer)="onDateChanged($event)">
        </app-question-multiple-date-picker> -->
      </div>
    </div>
    <div class="modal-alert__button">
      <div class="container">
        <a href="javascript:void(0)"
          class="button button--lg button--primary"
          [attr.disabled]="!buttonEnabled ? true : null"
          (click)="populateProperties()">
          Next
        </a>
      </div>
    </div>
  </div>
</div>
</div>

<div  class="modal fade modal--alert" id="pause-summary-modal" tabindex="-1" role="dialog"
  aria-labelledby="pause-summary-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" (click)="closePauseSummaryModal()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Are you sure you want to pause your {{entity === entities.Policy ? 'policy ' + policy?.product_name
              : entity === entities.Item ? 'item ' + (item?.description_2 ? item?.description_2 : item?.item_description_2 )
            : 'addon ' + vap?.detail}} cover from {{startFullDate | date: 'd MMM yyyy'}} ?</h4>
          </div>
          <ul class="pause-summary mb-30">
            <li class="pause-summary__item">
              <div class="pause-summary__label">
                <p>Your cover will pause on:</p>
              </div>
              <div class="pause-summary__value">
                <strong>{{startFullDate | date: 'dd MMM yyyy'}}</strong>
              </div>
            </li>
            <li class="pause-summary__item">
              <div class="pause-summary__label">
                <p>Your cover will resume on:</p>
              </div>
              <div class="pause-summary__value">
                <strong>{{endFullDate | date: 'dd MMM yyyy'}}</strong>
              </div>
            </li>

          </ul>
          <div class="form-group">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox" [(ngModel)]="agreeChecked" (ngModelChange)="onAgreeChecked()">
              <span class="custom-input__indi"></span>
              <span
              class="custom-input__label">I agree that I will not be able to claim during the paused period.</span>
            </label>
          </div>
          <hr class="hr--bdr hr--sm"/>
          <div class="note note--naked">
            <div class="note__content" [innerHTML]="refund?.description[0]?.itk">

            </div>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a
            href="javascript:void(0)"
            (click)="removeAction(2)"
            id="pause-summary-no"
            class="button button--lg button--secondary"
            data-dismiss="modal">
            No, Don't Pause
          </a>
          <a
            href="javascript:void(0)"
            [attr.disabled]="!pauseButtonEnabled ? true : null"
            class="button button--lg button--primary"
            data-dismiss="modal"
            (click)="changeToPaused()">
            Yes, Pause Cover
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


